import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    ym?: (...args: any[]) => void;
  }
}

const METRIKA_COUNTER_ID = 110571155;

const YandexMetrikaSpaTracker = () => {
  const location = useLocation();
  const isFirstHitRef = useRef(true);

  useEffect(() => {
    if (isFirstHitRef.current) {
      isFirstHitRef.current = false;
      return;
    }

    if (!window.ym) return;

    window.ym(METRIKA_COUNTER_ID, "hit", `${window.location.origin}${location.pathname}${location.search}${location.hash}`, {
      referer: document.referrer,
      title: document.title,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default YandexMetrikaSpaTracker;
